export default __webpack_public_path__ + "static/media/background.e351f535.png";